import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getNotes = (state: RootState) => state.pages.editor.scene.notes;

const getSceneNotes = createSelector([getNotes], (notes) => notes);

export default getSceneNotes;
